<template>
   <div class="sa-main" data-v-9c14ebd6>
      <div class="nuxt-loading-indicator" style="position:fixed;top:0;right:0;left:0;pointer-events:none;width:0%;height:5px;opacity:0;background:repeating-linear-gradient(to right,#00dc82 0%,#34cdfe 50%,#0047e1 100%);background-size:Infinity% auto;transition:width 0.1s, height 0.4s, opacity 0.4s;z-index:999999;"></div>
      <div class="index-wrap" data-v-c87589f3>
         <!-- banner图 -->
         <div class="banner" data-v-c87589f3>
            <img class="banner-pc-img" src="@/assets/image/home/banner-pc.png" data-v-c87589f3>
            <img class="banner-img" src="@/assets/image/home/banner.png" data-v-c87589f3>
            <div class="sa-button banner-btn is-active" plain data-v-c87589f3 @click="jump('/function',1)">了解详情<!-- <a href="/function">了解详情</a> -->
			</div>
			

												
         </div>
         <!-- 技术栈 -->
         <div class="el-row main-technology" style="" data-v-c87589f3>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-c87589f3></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18 technology-content" style="" data-v-c87589f3>
               <img class="bg" src="@/assets/image/home/bg.png" data-v-c87589f3>
               <div class="name" data-v-c87589f3>使用的技术栈 </div>
               <div class="right sa-flex sa-flex-wrap" data-v-c87589f3>
                  <div v-for="item,index in jszlist" :key="index">
                     <div class="item" data-v-c87589f3>
                        <img :src="item.logo" data-v-c87589f3>
                        <div data-v-c87589f3>{{item.name}}</div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-c87589f3></div>
         </div>
         

         <!-- 强有力的技术支持，品质更有保证 -->
         <div class="el-row main-contact panel-block" data-v-c87589f3 data-v-3aab1612 style="background-color: #fafaff;">
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-3aab1612>
               <div class="sa-name" data-v-3aab1612>强有力的技术支持，品质更有保证 </div>
               <div class="row">
                  <div class="characteristic">
                     <div class="item">
                        <div class="icon">
                           <i class="iconfont icon-yuanma"></i>
                        </div>
                        <div class="details">
                           <h5>多端技术栈uniapp开发</h5>
                           <p>uni-app不仅是小程序开发框架、也是App跨平台框架、H5开发框架，可以一键发行多端快速开展业务</p>
                        </div>
                     </div>
                     <div class="item">
                        <div class="icon">
                           <i class="iconfont icon-fenxiang2"></i>
                        </div>
                        <div class="details">
                           <h5>API接口，跨平台互通</h5>
                           <p>购物车数据自动同步、跨平台播放直播，APP小程序推流直播，不在是单一的小程序播放直播</p>
                        </div>
                     </div>
                     <div class="item">
                        <div class="icon">
                           <i class="iconfont icon-bingfajiankong"></i>
                        </div>
                        <div class="details">
                           <h5>高并发解决方案</h5>
                           <p>不是简单压力测试，我们已经拥有每秒万级高并发客户实际运营，且已上线版本已经针对高并发进行优化</p>
                        </div>
                     </div>
                     <div class="item">
                        <div class="icon">
                           <i class="iconfont icon-anquan"></i>
                        </div>
                        <div class="details">
                           <h5>系统安全稳定</h5>
                           <p>经过已售客户实测目前平台安全稳定，即使服务器卡顿高并发情况下，系统全部拦截错误订单保障数据安全</p>
                        </div>
                     </div>
                  </div>
                  <div class="update">
                     <div class="corrugated">
                        <div class="wave-top wave-item"></div>
                        <div class="wave-middle wave-item"></div>
                        <div class="wave-bottom wave-item"></div>
                     </div>
                     <div class="sketch">
                        <img src="@/assets/image/sketch.png">
                     </div>
                     <div class="col-md-12 col-xs-12 col-sm-12 text-center">
                        <div class="title">
                           <h3>后续更新计划</h3>
                           <p>此计划不代表是你定制或承若功能，请关注公司群了解最新动态</p>
                        </div>
                     </div>
                     <div class="col-md-12 col-xs-12 col-sm-12 list">
                       
                        <div class="item">
                           <div class="itemin">
                              <div class="icon">
                                 <i class="iconfont icon-VIP"></i>
                              </div>
                              <div class="details">
                                 <h6>优惠券功能</h6>
                                 <p>陪玩会员卡优惠券，参与陪玩中心活动</p>
                              </div>
                           </div>
                        </div>
                        <div class="item">
                           <div class="itemin">
                              <div class="icon">
                                 <i class="iconfont icon-21guanli"></i>
                              </div>
                              <div class="details">
                                 <h6>客户端管理</h6>
                                 <p>计划 在原客户端内增加商家管理功能</p>
                              </div>
                           </div>
                        </div>
                        <div class="item">
                           <div class="itemin">
                              <div class="icon">
                                 <i class="iconfont icon-zuanshi"></i>
                              </div>
                              <div class="details">
                                 <h6>营销功能</h6>
                                 <p>商城计划开发 秒杀、分销、砍价、敬请期待</p>
                              </div>
                           </div>
                        </div>
                        <div class="item">
                           <div class="itemin">
                              <div class="icon">
                                 <i class="iconfont icon-vuejs"></i>
                              </div>
                              <div class="details">
                                 <h6>独立陪玩中心</h6>
                                 <p>发行Vue陪玩中心PC端和独立陪玩中心手机端</p>
                              </div>
                           </div>
                           
                        </div>
                     </div>
                  </div>
               </div>
             </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
         </div>

         <!-- 核心优势 -->
         <div class="el-row main-contact panel-block" style="" data-v-c87589f3 data-v-3aab1612>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-3aab1612>
               <div class="sa-name" data-v-3aab1612>核心优势 </div>
               <img class="content-img" src="@/assets/image/home/core.png" data-v-3aab1612>
             </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
         </div>

         <!-- 功能特性 -->
         <div class="el-row main-function panel-block" style="" data-v-c87589f3 data-v-79958735>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-79958735></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-79958735>
               <div class="sa-name" data-v-79958735>功能特性 </div>
               <div class="function-content" data-v-79958735>
                  <div class="el-row" style="margin-left:-10px;margin-right:-10px;" data-v-79958735>
                     <div class="el-col el-col-24 el-col-xs-12 el-col-sm-12 el-col-md-8 el-col-lg-6 el-col-xl-6 is-guttered"
                     style="padding-right:10px;padding-left:10px;" data-v-79958735 
                     v-for="(elment,value) in gntxlist" :key="value">
                        <div class="function-block" data-v-79958735>
                           <div class="mask" data-v-79958735>
                              <div class="sa-flex" data-v-79958735>
                                 <img class="icon" :src="elment.img" data-v-79958735>
                                 <div class="name" data-v-79958735>{{elment.name}}</div>
                              </div>
                              <div class="desc" data-v-79958735>{{elment.text}}</div>
                           </div>
                           <div class="line-1" data-v-79958735></div>
                           <div class="line-2" data-v-79958735></div>
                           <div class="line-3" data-v-79958735></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-79958735></div>
         </div>
         <!-- 我们的资质 -->
         <div class="el-row main-contact panel-block" style="" data-v-c87589f3 data-v-3aab1612>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-3aab1612>
               <div class="sa-name" data-v-3aab1612>我们的资质 </div>
			   <!-- swiperbox -->
			   <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24"
			      data-v-ba2790b9="">
			      <div data-v-ba2790b9="" class="preview-content sa-flex sa-row-center">
			         <div data-v-ba2790b9="" class="el-scrollbar">
			            <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
			               <div class="el-scrollbar__view" style="">
			                  <div data-v-ba2790b9="" class="sa-shadow-wrap sa-flex">
			                     <div data-v-ba2790b9="" class="sa-button " :class="[previewindex == 0 && 'is-active']" @click="previewindex = 0">资质</div>
			                     <div data-v-ba2790b9="" class="sa-button " :class="[previewindex == 1 && 'is-active']" @click="previewindex = 1">软著</div>
			                  </div>
			               </div>
			            </div>
			         </div>
			      </div>
               <div class="swiperbox">
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev" @click="prev"></div>
                  <div class="swiper-button-next" @click="next"></div>
                  <div class="swiper" id="swiper">
                     <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in preview[previewindex].items" :key="index"
                           @click="previerimg(index,item)">
                           <img :src="item"/>
                        </div>
                     </div>
                     <!-- 如果需要分页器 -->
                     <div class="swiper-pagination"></div>
                     
                     
                     
                     <!-- 如果需要滚动条 -->
                     <div class="swiper-scrollbar"></div>
                  </div>
               </div>
               
				  
			   </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-3aab1612></div>
            
            
            
         </div>

         <!-- 立即咨询 -->
         <div data-v-c87589f3>
            <div class="el-row main-contact panel-block" style="" data-v-c87589f3 data-v-9f69f5e7>
              <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-9f69f5e7></div>
               <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-9f69f5e7>
                  <div class="sa-name" data-v-9f69f5e7>立即咨询 </div>
                  <div class="contact-content sa-flex sa-row-center" data-v-9f69f5e7>
                     <div class="contact-block sa-block" data-v-9f69f5e7>
                        <div class="shadow-1" data-v-9f69f5e7></div>
                        <div class="shadow-2" data-v-9f69f5e7></div>
                        <div class="shadow-3" data-v-9f69f5e7></div>
                        <div class="mask sa-flex" data-v-9f69f5e7>
                           <img class="qrcode" src="@/assets/image/home/qrcode-h5.png" data-v-9f69f5e7>
                           <div class="right" data-v-9f69f5e7>
                              <div class="title sa-line-1" data-v-9f69f5e7>火烈鸟科技有限公司欢迎您！ </div>
                              <div class="desc" data-v-9f69f5e7>扫码加微信客服咨询更多内容。 </div>
                              <div class="time" data-v-9f69f5e7>咨询服务 9:00-18:00 </div>
                           </div>
                        </div>
                     </div>
                  </div>
                </div>
               <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-9f69f5e7></div>
            </div>
         </div>
      </div>
      <div class="popup" @click="showpreview = false">
         <div class="imgbox" :style="{wdith:imgwidth+'px',height:imgheight+'px'}">
            <img :width="imgwidth+'px'" :height="imgheight+'px'" :src="previewimg" alt="">
         </div>
      </div>       
   </div>
</template>
<script>
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'
 import router from '@/router/index';
   import { mapState,mapGetters,mapMutations,mapActions} from 'vuex'
import 'swiper/css';
   export default {
   name: 'home',
   watch: {
      showpreview(newval, oldval) {
         var imgbox = document.querySelector(".imgbox");
         var popup = document.querySelector(".popup");
         if (newval) {
            console.log(newval);
            popup.style.display = "block";
            setTimeout(() => {
               popup.style.opacity = "1";
            }, 16);
            
         } else {
            popup.style.opacity = "0";
            setTimeout(() => {
               popup.style.display = "none";
            }, 300);
         }
      },
         previewindex(newval, oldval) {
            let width = document.body.clientWidth;
            if (width > 1200) {
               this.mySwiper.params.slidesPerView = 4;
               } else if (width <= 1200 && width > 950) {
               this.mySwiper.params.slidesPerView = 3;
               } else if (width <= 950 && width > 600) {
               this.mySwiper.params.slidesPerView = 2;
               } else if (width <= 600) {
               this.mySwiper.params.slidesPerView = 1;
            } 
         }
      },
      data(){
         return {
            imgwidth: '',
            imgheight:'',
            showpreview:false,
            previewimg:'',
            mySwiper:null,
            swiperOption: {
               loop: false,  // 是否循环轮播
               autoplay: false,  // 是否可以自动轮播
               slidesPerView: 5,  // 可是区域内可展示多少个块
               spaceBetween: 30,  // 块之间间隔距离
               initialSlide:0,  // 默认初始显示块
               freeMode: false,
               // 显示分页
               pagination: {
                     el: '.swiper-pagination',
                     clickable: true
                  },
               // 设置点击箭头
               navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
               },
            },
            jszlist:[
               {
                  name:'ThinkPHP6',
                  logo:require('../assets/image/home/thinkphp6.png')
               }, {
                  name:'uni-app',
                  logo:require('../assets/image/home/uni-app.png')
               }, {
                  name:'Vue3',
                  logo:require('../assets/image/home/vue3.png')
               },/* {
                  name:'Vite',
                  logo:require('../assets/image/home/vite.png')
               }, */{
                  name:'Redis',
                  logo:require('../assets/image/home/redis.png')
               },{
                  name:'Workerman',
                  logo:require('../assets/image/home/workerman.png')
               },{
                  name:'layui',
                  logo:require('../assets/image/home/layui.png')
               },{
                  name:'MySQL',
                  logo:require('../assets/image/home/mysql.png')
               }
            ],

            gntxlist:[
               {
                  img:require('@/assets/image/home/platform.png'),
                  name:'主流客户端适配',
                  text:'微信公众号、微信小程序、H5网页、Android/iOS APP多终端'
               },{
                  img:require('@/assets/image/home/decoration.png'),
                  name:'即时通讯',
                  text:'客户一对一发送文字、图片、语音内容进行多终端聊天'
               },{
                  img:require('@/assets/image/home/deposit.png'),
                  name:'支付/充值余额/商家转账',
                  text:'内置微信/支付宝支付与出账功能，支持微信生态下的支付宝支付功能'
               },{
                  img:require('@/assets/image/home/share.png'),
                  name:'全端分享',
                  text:'一键分享:微信公众号SDK、微信小程序卡片，CANVAS客户端海报绘制，APP开放平台，复制链接'
               },{
                  img:require('@/assets/image/home/dashboard.png'),
                  name:'数据统计',
                  text:'用户增长趋势、分享活跃趋势、订单数据统计、销量榜、热搜榜等常用高性能图表'
               },{
                  img:require('@/assets/image/home/express.png'),
                  name:'安全内容过滤',
                  text:'对接七牛等第三方接口，实时过滤安全内容'
               },{
                  img:require('@/assets/image/home/login.png'),
                  name:'多端登录',
                  text:'集成:手机号+验证码，用户名/手机号+密码，微信公众号/小程序/开放平台授权登录，iOS登录'
               },{
                  img:require('@/assets/image/home/score.png'),
                  name:'积分商城',
                  text:'丰富的积分获取渠道:充值赠积分、签到得积分、活动赚积分，积分+现金兑换积分商品'
               },{
                  img:require('@/assets/image/home/wechat.png'),
                  name:'微信公众号管理',
                  text:'一键对接微信公众号API，完成自动回复、自定义菜单，接替您实现公众号的更多功能'
               },{
                  img:require('@/assets/image/home/service1.png'),
                  name:'客服系统',
                  text:'Socket.io原生客服实现，无需对接任何第三方套件，构建您专属的实时客服聊天系统'
               },{
                  img:require('@/assets/image/home/warning.png'),
                  name:'广告设置',
                  text:'对接腾讯云流量主广告SDK'
               },{
                  img:require('@/assets/image/home/message.png'),
                  name:'消息通知',
                  text:'特定事件触发下向客户推送消息通知与提醒，支持短信、微信小程序订阅消息、微信公众号模板消息、邮箱多重渠道'
               },{
                  img:require('@/assets/image/home/commission.png'),
                  name:'商城系统',
                  text:'强大的商城系统，可以出售虚拟道具或实物，请在演示站中浏览体验'
               },{
                  img:require('@/assets/image/home/batch.png'),
                  name:'礼物系统',
                  text:'支持svga动画特效文件，语聊房和一对一聊天皆可送礼物'
               },{
                  img:require('@/assets/image/home/discounts.png'),
                  name:'宝箱功能',
                  text:'用户开启宝箱可获得想用礼品，用于平台经营营销功能'
               },{
                  img:require('@/assets/image/home/coupons.png'),
                  name:'大转盘',
                  text:'成为会员后可每天参与积分抽奖，获取的积分兑换对应的积分礼品'
               },{
                  img:require('@/assets/image/home/group.png'),
                  name:'会员功能',
                  text:'专享专属勋章/隐身状态/每日抽奖/动态置顶/专属礼物/积分经验等功能'
               },{
                  img:require('@/assets/image/home/mplive.png'),
                  name:'短视频功能',
                  text:'以短视频播放页面展示用户在动态内发的视频内容'
               },{
                  img:require('@/assets/image/home/offline.png'),
                  name:'道具商城',
                  text:'可购买道具卡/挂饰/头像框/聊天气泡等道具商品'
               },{
                  img:require('@/assets/image/home/virtual.png'),
                  name:'动态社区',
                  text:'可发布文字/图片/语音/视频/付费/链接/网盘/投票/红包等内容'
               }
            ],

            preview:[{
               label: "资质",
               value: "aptitude",
               items: [
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/1.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/2.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/3.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/4.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/5.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/6.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/7.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/8.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/9.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/zizhi/10.jpg',

                ]
            }, {
               label: "软著",
               value: "soft",
               items: [
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/1.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/2.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/3.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/4.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/5.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/6.jpg',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/ruanzhu/7.jpg',
                ]
            }],
            previewindex: 0,
            swiperindex:0,
         }
      },
      methods:{
		  ...mapMutations(['getState']),
		  jump(path,index){
		     this.showmenu = false;
		     this.getState({index})
		     this.$router.push(path,()=>{})
		  },
         next() {
            this.mySwiper.slideNext()
         },
         prev() {
            this.mySwiper.slidePrev()
         },
         previerimg(index, item) {
            console.log(12121);
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            var img = new Image();
            img.src = item;
            
            let bi = img.width / img.height;
            //90%高
            if ((0.9*height)*bi < width) {
               this.imgwidth = 0.9 * height * bi;
               this.imgheight = 0.9*height
            } else {
               this.imgwidth = 0.6 * width;
               this.height = 0.9 * height / bi
            }
            this.previewimg = item;
            this.showpreview = true
         }
      },
      
   mounted() {
      window.scrollTo({top: 0, behavior:'smooth'});
         window.addEventListener('resize', (e) => {
            let width = document.body.clientWidth;
            if (width > 1200) {
              this.mySwiper.params.slidesPerView = 4;
            } else if (width <= 1200 && width > 950) {
              this.mySwiper.params.slidesPerView = 3;
            } else if (width <= 950 && width > 600) {
              this.mySwiper.params.slidesPerView = 2;
            } else if (width <= 600) {
              this.mySwiper.params.slidesPerView = 1;
            } 
         })
      let width = document.body.clientWidth;
      let slidesPerView = 4;
         if (this.previewindex == 0) {
            if (width > 1200) {
               slidesPerView = 4;
            } else if (width <= 1200 && width > 950) {
               slidesPerView = 3;
            } else if (width <= 950 && width > 600) {
               slidesPerView = 2;
            } else if (width <= 600) {
               slidesPerView = 1;
            }
         } 
         this.mySwiper = new Swiper ('#swiper', {
            direction: 'horizontal', // 垂直切换选项
            loop: false, // 循环模式选项
            grabCursor: true,
            slidesPerView,  
            spaceBetween:50,
            // 如果需要分页器
            pagination: {
               el: '.swiper-pagination',
            },
            
            // 如果需要前进后退按钮
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
            
            // 如果需要滚动条
            scrollbar: {
               el: '.swiper-scrollbar',
            },
         })
      },
   };
</script>
<style scoped>
   @import '../assets/css/index.css';
   @import '../assets/css/navigation.css';
   .swiperbox{
      position: relative;
   }
   .swiper-button-prev{
      position: absolute;
      left: -.4rem;
      top: 50%;
      /* transform: translateY(-50%); */
      width: 0.5rem;
      height: 0.5rem;
      background-color: #806af6;
      border-radius: 0.1rem;
      color: #fff;
   }
   .swiper-button-prev:hover{
      background-color: #b4a7ff;
   }
   .swiper-button-prev:after{
      font-size: 0.3rem !important;
   }
   .swiper-button-next{
      position: absolute;
      right: -0.4rem;
      top: 50%;
      /* transform: translateY(-50%); */
      width: 0.5rem;
      height: 0.5rem;
      background-color: #806af6;
      border-radius: 0.1rem;
      color: #fff;
      
   }
   .swiper-button-next:hover{
      background-color: #b4a7ff;
   }
   .swiper-button-next:after{
      font-size: 0.3rem !important;
   }
   @media (max-width: 512px) and (min-width: 320px) {
      .swiper-button-next {
         width: 40px;
         height: 40px;
         border-radius: 8px;
      }
      .swiper-button-prev {
         width: 40px;
         height: 40px;
         border-radius: 8px;
      }
   }
   @media (min-width: 900px) {
      .swiper-button-next {
         right: -0.7rem;
      }
      .swiper-button-prev {
         left: -0.7rem;
      }
   }
   @media (max-width: 800px) {
      .swiper-button-next {
         right: -0.2rem;
      }
      .swiper-button-prev {
         left: -0.2rem;
      }
   }
   @media  (max-width: 320px) {
      .swiper-button-next {
         width: 25px;
         height: 25px;
         border-radius: 3px;
      }
      .swiper-button-prev {
         width: 25px;
         height: 25px;
         border-radius: 3px;
      }
   }
   .popup{
      position: fixed;
      transition: all 0.3s ease-in-out;
      display: none;
      top:0;
      opacity: 0;
      left:0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      z-index: 999;
   }
   .popup .imgbox{
      transition: all 0.11s ease-in-out;
      position: fixed;
      top:50%;
      left:50%;
      transform: translate(-50% ,-50%);
   }
   .swiper{
      padding:20px 40px;
      width: 100%;
	   /* position: relative; */
	   /* overflow: unset; */
      /* height: 500px; */
   }
   .swiper-wrapper {
      position: relative;
      width: 100%;
      /* overflow: hidden; */
   }
   
   .swiper-wrapper .swiper-slide {
      width: 50px;
      height: 100%;
      padding: 10px;
      border-radius: 20px;
      background-color: #eee9ff;
   }
   .swiper-wrapper .swiper-slide img{
      width: 100%;
      height: 100%;
      border-radius: 15px;
   }
   @media (max-width: 1000px) {
      .swiper-wrapper .swiper-slide {
         padding: 0.08rem !important;
         border-radius: 0.08rem;
      }
      .swiper-wrapper .swiper-slide img{
         border-radius: 0.08rem;
      }
   }
.row {
   display: flex;
   align-items: flex-start;
   justify-content: space-between;
   margin-top: 60px;
   
}
@media (max-width: 1000px) {
    .row {
      display: block;
    }
    .row .characteristic{
      width: 100%;
    }
    .row .update{
      margin-top: 80px;
      width: 100%;
    }
   
}
.characteristic{
   width: 48%;
}
.characteristic .item {
    display: flex;
    align-items: flex-start;
    margin-top: 40px;
}
.characteristic .item:nth-child(1) {
   margin-top: 0px;
}

.characteristic .item .icon {
    width: 0.5rem;
    height: 0.5rem;
    font-size: 0.2rem;
    padding-top: 3px;
    color: #806af6;
    flex-shrink: 0;
    
}
.characteristic .item .icon i{
   font-size: 0.3rem;
}
.characteristic .item:hover .icon {
    -webkit-animation: bounce 1s 0s ease both;
    -moz-animation: bounce 1s 0s ease both;
    animation: bounce 1s 0s ease both;
}

.characteristic .item .details {
    flex: 1;
}

.characteristic .item .details h5 {
   margin: 0;
    margin-bottom: 0.1rem;
    font-size: 0.2rem;
}

.characteristic .item .details p {
   font-size: 0.15rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin: 0;
}
.update {
   position: relative;
   width: 48%;
   padding-top:150px;
   background-color: #fff;
}

@media (min-width: 768px) {
    .update {
      position: relative;
      /* margin: 47px 0 10px 35px; */
    }
}

.update .corrugated {
    background-image: linear-gradient(to top, #6b53f0, #806af6);
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 150px;
    overflow: hidden;
    z-index: 20;
    border-radius: 15px 15px 0 0;
}

.update .corrugated .wave-item {
    position: absolute;
    width: 200%;
    left: 0;
    height: 150px;
    background-repeat: repeat-x;
    background-position: 0 bottom;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom
}

.update .corrugated .wave-top {
    opacity: .5;
    -webkit-animation: wave-animation 3s;
    animation: wave-animation 3s;
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
    background-size: 50% 50px;
    z-index: 15;
    background-image: url(../assets/image/home/wave-top.png);
}

.update .corrugated .wave-middle {
    opacity: .75;
    -webkit-animation: wavemove-data 10s linear infinite;
    animation: wavemove-data 10s linear infinite;
    background-size: 50% 45px;
    z-index: 10;
    background-image: url(../assets/image/home/wave-mid.png);
}

.update .corrugated .wave-bottom {
    -webkit-animation: wavemove-data 15s linear infinite;
    animation: wavemove-data 15s linear infinite;
    background-size: 50% 40px;
    z-index: 5;
    background-image: url(../assets/image/home/wave-bot.png);
}

.update .sketch {
    width: 100%;
    position: absolute;
    top: -75px;
    z-index: 30;
    text-align: center;
}

.update .sketch img {
    width: 420px;
    vertical-align: middle;
    margin:0 auto;
}
@media (max-width: 500px) {
   .update .sketch img {
      width: 6rem;
   }
}
@media (max-width: 900px) {
   .text-center .title h3 {
      font-size: 0.3rem !important;
   }

   .text-center .title p {
      font-size: 0.2rem !important;
   }
}
.text-center .title h3 {
   text-align: center;
   font-size: 28px;
}

.text-center .title p {
   text-align: center;
    color: #333333;
    opacity: 0.6;
    font-size: 14px;
 }

/* 更新模块 */
.update .list {
    background-color: #fff;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-radius: 0 0 12px 12px;
    box-shadow: 0px 0px 16px 2px rgba(213, 213, 213, 0.3);
}
.update .list{
   display: flex;
   flex-wrap: wrap;
   text-align: center;
   padding: 0.15rem;
}
.update .list .item {
  width: 49%;
  margin-right:2%;
  margin-bottom: 30px;
   border-radius: 5px;
   max-height: 100px;
   
   background-color: #fafaff;
}
.update .list .item:nth-child(2n){
   margin-right:0;
}
.update .list .item .itemin{
   display: flex;
    align-items: center;
    padding:10px;
   
}

.update .list .item .icon {
    margin-right: 0.1rem;
    font-size: 0.2rem;
    background-color: #e8e3ff;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    color: #806af6;
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    
}
.update .list .item .icon i{
   font-size: 0.3rem;
   
}
.update .list .item:hover .icon {
    -webkit-animation: tada 1s 0s ease both;
    -moz-animation: tada 1s 0s ease both;
    animation: tada 1s 0s ease both;
}

.update .list .item .details h6 {
    color: #333333;
    margin-top: 0;
    margin-bottom: 2px;
    font-size: 0.15rem;
    text-align: left;
}

.update .list .item .details p {
    font-size: 14px;
    text-align: left;
    color: #333333;
    font-weight: 500;
    opacity: 0.6;
    margin: 0;
    font-size: 0.12rem;
}

.update .window {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 60px;
    height: 32px;
    position: absolute;
    left: 8px;
    top: -32px;
}

.update .window span {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #fb615b;
}

.update .window span:nth-child(2) {
    background-color: #fdbc40;
}

.update .window span:nth-child(3) {
    background-color: #40c649;
}
@-webkit-keyframes wavemove-data {
    0% {
        -webkit-transform: translateX(0) translateZ(0) scaleY(1);
        transform: translateX(0) translateZ(0) scaleY(1)
    }

    50% {
        -webkit-transform: translateX(-25%) translateZ(0) scaleY(.55);
        transform: translateX(-25%) translateZ(0) scaleY(.55)
    }

    100% {
        -webkit-transform: translateX(-50%) translateZ(0) scaleY(1);
        transform: translateX(-50%) translateZ(0) scaleY(1)
    }
}

@keyframes wavemove-data {
    0% {
        -webkit-transform: translateX(0) translateZ(0) scaleY(1);
        transform: translateX(0) translateZ(0) scaleY(1)
    }

    50% {
        -webkit-transform: translateX(-25%) translateZ(0) scaleY(.55);
        transform: translateX(-25%) translateZ(0) scaleY(.55)
    }

    100% {
        -webkit-transform: translateX(-50%) translateZ(0) scaleY(1);
        transform: translateX(-50%) translateZ(0) scaleY(1)
    }
}
</style>